import "./auth.scss";
import React from "react";
import ResetPasswordForm from "../../components/Forms/AuthForms/ResetPasswordForm";
import onco_mark from "../../assets/logos/ONCOEVIDA.svg";

const ResetPassword = () => {
  return (
    <div className="myCustomLogin">
      <div className="logoPart container">
        <div className="logoContainer">
          <img src={onco_mark} alt="" />
        </div>
      </div>
      <div className="formPart">
        <div className="contact">
          <ResetPasswordForm />
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
